import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { BlogsService } from '../../services/blogs-service';
import { AddBlogComponent } from '../add-blog/add-blog.component';
import { FileUploaderComponent } from '../../../../shared/Components/file-uploader/file-uploader.component';
import { GetBlogsDetailsComponent } from '../get-blogs-details/get-blogs-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';
@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss'],
})
export class GetBlogsComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: BlogsService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService
  ) {
    super(route, service, paging, '', diag);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  intitForm() {
    this.form = this.fb.group({
      titleAR: [''],
    });
  }

  handleSearch() {
    if (!this.form.value.titleAR && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاءاختيار الاسم او التاريخ لاتمام عمليةالبحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.titleAR) {
      serchTermArr.push(`titleAR:${this.form.value.titleAR.trim()}`);
    }

    if (this.dateFrom) {
      let dateInput = document.getElementById('dateFrom') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateFrom = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`dateTime:>${dateFrom}`);
    }
    if (this.dateTo) {
      let dateInput = document.getElementById('dateTo') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateTo = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`dateTime:<${dateTo}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['titleAR'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  addNewBlog() {
    this.dialog
      .open(AddBlogComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(GetBlogsDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddBlogComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
